import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';



export const fetchRoles = createAsyncThunk(
  'role/fetchRoles',
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("vedhvidhi-admin-token");
      const config = {
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      };
      const res = await axios.get(`${process.env.REACT_APP_BASEURL}/admin/role`, config);
      return res.data?.data || [];
    } catch (err) {
      return rejectWithValue(err.message || "Failed to fetch roles");
    }
  }
);

export const updateRole = createAsyncThunk(
  'role/updateRole',
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("vedhvidhi-admin-token");
      const config = {
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      };
      const res = await axios.patch(`${process.env.REACT_APP_BASEURL}/admin/role/${id}`, formData, config);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Failed to update role");
    }
  }
);

const roleSlice = createSlice({
  name: 'role',
  initialState: {
    roles: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchRoles.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchRoles.fulfilled, (state, action) => {
        state.loading = false;
        state.roles = action.payload;
      })
      .addCase(fetchRoles.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default roleSlice.reducer;
